import { EXPRESS_ENTRY } from './economic/expressEntry.js';
import { OINP_WORKFORCE_PRIORITY, PNP_PERMANENT_RESIDENCE } from './economic/provincial.js';
import { ATLANTIC, CAREGIVERS, RURAL_FRANCOPHONE, START_UP_VISA } from './economic/federalPrograms.js';
import { SPOUSE_PARTNER } from './family/spousePartner.js';
import { DEPENDENT_CHILD } from './family/dependentChild.js';
import { PARENTS_GRANDPARENTS } from './family/parentsGrandparents.js';
import { SUPER_VISA } from './temporary/superVisa.js';
import { VISITOR_RECORD, VISITOR_VISA } from './temporary/visitor.js';
import { STUDY_PERMIT, STUDY_PERMIT_EXTENSION } from './temporary/study.js';
import { IEC, PGWP, WORK_PERMIT_LMIA, WORK_PERMIT_LMIA_EXEMPT } from './temporary/work.js';
import { SPOUSE_OPEN_WORK_PERMIT } from './temporary/spouseOpenWorkPermit.js';
import { CITIZENSHIP, PR_CARD, PRTD } from './citizenship/status.js';
import { H_AND_C } from './humanitarian/handc.js';
import { BVOR, GROUP_OF_FIVE, PRRA, RAD_APPEAL, REFUGEE_CLAIM } from './refugee/refugee.js';
import { IAD_RESIDENCY, IAD_SPONSORSHIP, JUDICIAL_REVIEW } from './appeals/appeals.js';
import type { IProgram, ProgramFamily } from './types.js';

export * from './types.js';
export { buildChecklist, diffChecklist, holds, peopleProblems, type IChecklistLine, type IPerson } from './checklist.js';
export { COMMON_DEADLINES, dueDate, RESIDENCY_DEADLINES, rulesFor, WEEKEND_NOTE } from './deadlines.js';

/** Every program, in the order they're offered. */
export const PROGRAMS: IProgram[] = [
  SPOUSE_PARTNER, DEPENDENT_CHILD, PARENTS_GRANDPARENTS,
  VISITOR_VISA, SUPER_VISA, VISITOR_RECORD, STUDY_PERMIT, STUDY_PERMIT_EXTENSION,
  PGWP, WORK_PERMIT_LMIA, WORK_PERMIT_LMIA_EXEMPT, SPOUSE_OPEN_WORK_PERMIT, IEC,
  EXPRESS_ENTRY, OINP_WORKFORCE_PRIORITY, PNP_PERMANENT_RESIDENCE, ATLANTIC, CAREGIVERS, RURAL_FRANCOPHONE, START_UP_VISA,
  CITIZENSHIP, PR_CARD, PRTD,
  H_AND_C,
  REFUGEE_CLAIM, RAD_APPEAL, PRRA, GROUP_OF_FIVE, BVOR,
  IAD_SPONSORSHIP, IAD_RESIDENCY, JUDICIAL_REVIEW
];

export const FAMILY_LABELS: { [f in ProgramFamily]: string } = {
  family: 'Family sponsorship',
  economic: 'Economic immigration',
  temporary: 'Visits, study and work',
  citizenship: 'Citizenship and PR status',
  humanitarian: 'Humanitarian and compassionate',
  refugee: 'Refugee and protection',
  appeals: 'Appeals and Federal Court'
};

export function getProgram(id: string | undefined): IProgram | undefined {
  return PROGRAMS.filter(p => p.id === id)[0];
}
